// eslint-disable-next-line import/prefer-default-export
export const REVIEW_SERVICE_TYPE = {
  LOCALMED: 'LOCALMED',
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
  YELP: 'YELP',
};
